import * as React from 'react';
import { getPriceWithout } from '../../../helpers/Prices/getPrice';
var currencyFormatter = require('currency-formatter');

interface IPriceDisplayPriceType {
  currencyId: string;
  priceWithout?: number;
}

interface IPriceDisplayProps {
  amount?: number;
  prices?: IPriceDisplayPriceType[] | null;
  currency?: GQL.ICurrency | null;
  className?: string;
}

class PriceDisplay extends React.Component<IPriceDisplayProps> {

  public static currencyFormat = (amount: number, currencyCode: string) => {
    return currencyFormatter.format(amount, { code: currencyCode });
  }

  public render() {
    const { amount, prices, currency, className } = this.props;

    if (amount !== undefined && amount !== null) {
      return (
        <span className={className}>
          {currency && !!currency.value
            ? PriceDisplay.currencyFormat(amount, currency.value)
            : amount}
        </span>
      );
    }

    if (!prices || !currency) {
      return null;
    }

    const filledPrices = prices.filter((price: IPriceDisplayPriceType) => !!price.priceWithout);

    return (
      <React.Fragment>
        <div>
          <strong>{getPriceWithout(prices, currency) || '-'} {currency.value || ''}</strong>
        </div>
        {filledPrices && filledPrices.length > 1 &&
          <React.Fragment>
            <small style={{ color: '#ff4d4f' }}>+ {filledPrices.length - 1} prices</small>
          </React.Fragment>}
        </React.Fragment>
    );
  }
}

export default PriceDisplay;


// WEBPACK FOOTER //
// ./src/components/Others/PriceDisplay/PriceDisplay.tsx